import { useCallback, useEffect, useState } from "react";
import { fetchCallAllDataByIDAPI } from "../utils/api";

const normalizeMap = (rawMap) => {
    const out = {};
    Object.entries(rawMap || {}).forEach(([key, value]) => {
        const code = String(key || "").trim().toUpperCase();
        const name = String(value || "").trim();
        if (code && name) out[code] = name;
    });
    return out;
};

const useSkillCenterMap = () => {
    const [centerByCode, setCenterByCode] = useState({});

    useEffect(() => {
        let active = true;
        fetchCallAllDataByIDAPI("ppc-skill-center-code-map").then((res) => {
            if (!active) return;
            if (res?.data?.status === 1) {
                setCenterByCode(normalizeMap(res?.data?.data?.map || {}));
            }
        }).catch(() => {
            if (active) setCenterByCode({});
        });

        return () => {
            active = false;
        };
    }, []);

    const deriveCenterName = useCallback((skillRaw) => {
        const skill = String(skillRaw || "").trim().toUpperCase();
        if (!skill) return "Other";

        const parts = skill.split("_").filter(Boolean);
        for (let i = 0; i < parts.length; i += 1) {
            const code = parts.slice(i).join("_");
            if (centerByCode[code]) return centerByCode[code];
        }

        const last = parts[parts.length - 1] || "";
        return centerByCode[last] || last || "Other";
    }, [centerByCode]);

    return { centerByCode, deriveCenterName };
};

export default useSkillCenterMap;
